import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import {
  getComponentById,
  getDataSourceByKey,
} from '@bingads-webui-campaign-react/smart-component-util';
import { SmartTextView } from './smart-text-view';

export const SmartTextConnector = (props) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const { id } = props;
  const componentConfig = getComponentById(siteConfig, id);
  const {
    content, placeholder, style, 'data-source-name': dataSourceName,
  } = componentConfig;

  let textContent = '';

  if (dataSourceName) {
    textContent = getDataSourceByKey(siteConfig, dataSourceName);
  } else {
    textContent = content;
  }

  if (!textContent) {
    textContent = placeholder;
  }
  return useMemo(() => (<SmartTextView
    content={textContent}
    style={style}
    id={id}
  />), [id, style, textContent]);
};

SmartTextConnector.propTypes = {
  id: PropTypes.string.isRequired,
};
